export { fetchStakeNamesTemplateByChangeLang } from './fetch-stake-names-template';
